const packageJson = require('../../package.json');

// Define where cesium's external assets are located (copied across from cesium's source during webpack's build / serve process)
window.CESIUM_BASE_URL = `./assets/cesium/${packageJson.devDependencies.cesium}/`;
/*
 * OPTION 1
 * Use Cesium from their minified build.
 * Smallest cesium build.
 * Smashes Cesium into the global scope.
 */
// import 'script-loader!../../node_modules/cesium/Build/Cesium/Cesium';
// import 'script-loader!../../../../cesium/Build/Cesium/Cesium';

/*
 * OPTION 2
 * Use Cesium from their unminified build.
 * One big cesium file, but not minified.
 * Leaves in DeveloperErrors.
 * Smashes Cesium into the global scope.
 */
// import 'script-loader!../../node_modules/cesium/Build/CesiumUnminified/Cesium';

/*
 * OPTION 3
 * Use Cesium from source.
 * Gives full source maps to Cesium's source code.
 * Leaves in DeveloperErrors.
 * Requires a GLSL webpack loader in the webpack config.
 * Doesn't add Cesium to the global scope.
 */
import * as C from 'cesium';
window.Cesium = C;

// Export the cesium constant (we shouldn't be using it directly from the window)
export const Cesium = window.Cesium;

// Other note:
// Unfortunately we can't do: import { thing } from 'cesium'; anymore
// because now tha Cesium is using real es6 modules, if we do that import we'll get the real source code, not just the type!
// this is quite nice to get the source code, but it means we have to build/minify cesium ourselves, which is just huge and slow.
// and we can't minify it as good as cesium can, so we should be using their build output, not their source code.
// Types do come from the global though
